/// <amd-module name="Test/TestResultsGridToolbar/Actions/TestResultsToolbarActionshub" />
import { Action } from "VSS/Reflux/Action";
import { FilterState } from "Test/common-util/Contracts/Filters";

export class TestResultsToolbarActionsHub {
    public onGroupByChanged = new Action<string>();
    public filterChanged = new Action<FilterState>();
    public onToggleFilter = new Action<void>();
    public updateReloadButton = new Action<boolean>();
    public updateManualMarkUnMarkFlakyValue = new Action<Boolean>();
}
